import React, { useState, useEffect, useRef } from 'react';

const AnnouncementBox = () => {
    const listRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false); // Track hover state

    useEffect(() => {
        const interval = setInterval(() => {
            if (listRef.current && !isHovered) { // Only scroll if not hovered
                const scrollHeight = listRef.current.scrollHeight;
                const clientHeight = listRef.current.clientHeight;

                // Check if the bottom of the list is reached
                if (listRef.current.scrollTop + clientHeight >= scrollHeight) {
                    listRef.current.scrollTop = 0; // Reset scroll to the top when it reaches the bottom
                } else {
                    listRef.current.scrollTop += 1; // Scroll down gradually
                }
            }
        }, 30); // Speed of the scrolling (lower is faster)

        return () => clearInterval(interval); // Cleanup on component unmount
    }, [isHovered]); // Re-r) => clearInterval(interval); // Cleanup interval on component unmount


    return (
        <>
            <div className="announcement-box rounded shadow-sm p-3 pt-0 mb-5 bg-white"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)} >
                <div className="announcement-title  text-white text-center p-2 font-weight-bold" style={{ backgroundColor: "#1d3243 " }}>
                    Announcements
                </div>
                <div
                    className="announcement-list"
                    style={{ maxHeight: '200px', overflow: 'hidden', position: 'relative' }}
                    ref={listRef}
                >
                    <ul style={{ listStyleType: "disc" }} className=" p-2 m-0">
                        

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark">
                                A Proud moment for MRECW - Received an "Excellence Award 2026 form CISCO
                            </a>
                        </li>
                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/FDP-Effective-Research-Design-27-Dec-2025.jpeg" target="_blank">
                                Faculty Development Programme on Effective Research Design, Data Analysis and Scholarly Writing, held on 27th December, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/MRECW-NSS-Awareness-Programmes-27-Dec-2025.jpeg" target="_blank">
                                MRECW NSS Unit I &amp; II � Awareness Programmes, held on 27th December, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/Song-Release-Anaganaga-Oka-Raju-26-Dec-2025.jpeg" target="_blank">
                                Song Release Programme of the film Anaganaga Oka Raju, held on 26th December, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/IBM-SkillsBuild-Certification-Programme-23-Dec-2025.jpeg" target="_blank">
                                IBM SkillsBuild Certification Programme, held on 23rd December, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/Christmas-Celebrations-23-Dec-2025.jpeg" target="_blank">
                                Christmas Celebrations 2025, held on 23rd December, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/Farm-Tech-Innovation-Expo-23-Dec-2025.jpeg" target="_blank">
                                Farm-Tech Innovation Expo 2025, held on 23rd December, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/ICSCSP-2026-June-19-20.jpeg" target="_blank">
                                9th International Conference on Soft Computing and Signal Processing (ICSCSP-2026), to be held on June 19�20, 2026.
                            </a>
                        </li>

                    </ul>
                </div>
                <div className="announcement-footer  text-center" style={{ backgroundColor: "#1d3243 " }}>
                    <a href="/Home/Events" className="d-block p-2 font-weight-bold text-white text-decoration-none">
                        View All
                    </a>
                </div >
            </div >
        </>
    );
};

export default AnnouncementBox;
